import Vue from 'vue';
import Carousel from './components/Carousel';
import Modal from './components/Modal';
import Gallery from './components/Gallery';

Vue.component('modal', Modal);
Vue.component('carousel', Carousel);
Vue.component('gallery', Gallery);
